'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputField = exports.InputField = function (_React$Component) {
  (0, _inherits3.default)(InputField, _React$Component);

  function InputField() {
    (0, _classCallCheck3.default)(this, InputField);
    return (0, _possibleConstructorReturn3.default)(this, (InputField.__proto__ || (0, _getPrototypeOf2.default)(InputField)).apply(this, arguments));
  }

  (0, _createClass3.default)(InputField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          suppressErrorMessage = _props.suppressErrorMessage,
          suppressSuccessMessage = _props.suppressSuccessMessage,
          forceErrorState = _props.forceErrorState,
          id = _props.id,
          inputAttributes = _props.inputAttributes,
          inputClassNames = _props.inputClassNames,
          _props$inputTag = _props.inputTag,
          inputTag = _props$inputTag === undefined ? 'input' : _props$inputTag,
          label = _props.label,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          wrapperAttributes = _props.wrapperAttributes,
          wrapperTag = _props.wrapperTag,
          _props$isDisabled = _props.isDisabled,
          isDisabled = _props$isDisabled === undefined ? false : _props$isDisabled,
          children = _props.children;


      var fieldId = id || input.name + '_field';
      var hasError = forceErrorState || meta.error && meta.touched && !meta.active;
      var classes = [];

      if (hasError) {
        classes.push('form__input--error');
      } else if (!suppressSuccessMessage && meta.touched && !meta.active && inputTag === 'input' && input.value) {
        classes.push('form__input--valid');
      }

      if (inputClassNames) {
        classes.push(inputClassNames);
      }

      if (inputAttributes && inputAttributes.onBlur) {
        var onBlurFn = inputAttributes.onBlur;
        inputAttributes.onBlur = function composedBlur(event) {
          input.onBlur(event);
          return onBlurFn.call(this, event);
        };
      }

      var firstChild = _react2.default.Children.toArray(children)[0];
      var firstChildIsOption = firstChild && firstChild.type === 'option';

      var inputElement = _react2.default.createElement(inputTag, (0, _extends3.default)({
        className: classes.join(' '),
        type: type || 'text',
        id: fieldId,
        disabled: isDisabled
      }, input, inputAttributes), firstChildIsOption && children);

      var inputAndLabelElements = [label ? _react2.default.createElement(
        'label',
        { htmlFor: fieldId },
        label
      ) : null, inputElement];

      // If we are a checkbox, show the input BEFORE the label
      if (inputAttributes && inputAttributes.type === 'checkbox') {
        inputAndLabelElements = [inputAndLabelElements[1], inputAndLabelElements[0]];
      }

      var errorElement = void 0;
      if (hasError) {
        errorElement = typeof meta.error === 'string' ? meta.error : _react2.default.createElement(_reactIntl.FormattedMessage, meta.error);
      }

      return _react2.default.createElement.apply(_react2.default, [wrapperTag || 'div', wrapperAttributes || {}].concat((0, _toConsumableArray3.default)(inputAndLabelElements), [hasError && !forceErrorState && !suppressErrorMessage ? _react2.default.createElement(
        'div',
        { className: 'error__text text--sm mt-' },
        errorElement
      ) : null, !firstChildIsOption && children]));
    }
  }]);
  return InputField;
}(_react2.default.Component);

InputField.propTypes = {
  input: _propTypes2.default.object,
  meta: _propTypes2.default.object,
  children: _propTypes2.default.node,
  isDisabled: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  inputClassNames: _propTypes2.default.string,
  inputAttributes: _propTypes2.default.object,
  inputTag: _propTypes2.default.string,
  label: _propTypes2.default.element,
  type: _propTypes2.default.string,
  forceErrorState: _propTypes2.default.bool,
  suppressErrorMessage: _propTypes2.default.bool,
  suppressSuccessMessage: _propTypes2.default.bool,
  wrapperAttributes: _propTypes2.default.object,
  wrapperTag: _propTypes2.default.string
};